(() => {
  "use strict";
  const KEY = "ita_fit_v1";
  const $ = (s, r) => (r || document).querySelector(s), $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const esc = (t) => String(t == null ? "" : t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const fill = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (o[k] != null ? o[k] : m));
  const num = (v) => { const n = parseFloat(String(v).replace(",", ".")); return isFinite(n) ? n : null; };
  const X = '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  const mem = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    set(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} },
  };

  /* ---------- the page's data ---------- */
  function ctxOf(root) {
    if (!root) return null;
    let D, C, rule = null;
    try { D = JSON.parse($("[data-pd-json]", root).textContent); } catch (e) { return null; }
    try { C = JSON.parse($("[data-pd-fit-cfg]", root).textContent); } catch (e) { return null; }
    try { rule = JSON.parse(C.rule); } catch (e) { rule = null; }
    const G = D.g;
    if (!G || !G.rows || !G.rows.length || !G.cols) return null;
    const wi = G.cols.findIndex((c) => c[0] === "width");
    if (wi < 0 || !rule || !rule.body || !rule.ease_cm) return null;
    /* garment kind: the chart's family; an oversized cut (the garment's fit scale 2) uses the family + "_over" entry when the rule has one */
    const kind = G.sc >= 2 && rule.ease_cm[G.fam + "_over"] ? G.fam + "_over" : G.fam, ease = rule.ease_cm[kind] || null;
    if (!ease) return null;
    return { root, D, T: C.t || {}, rule, G, wi, ease, kind };
  }
  /* chest width of a size row in cm (the chart stores [cm, in]; either may be missing) */
  const widthCm = (r, wi) => { const v = r[wi + 1]; if (!v) return null; return v[0] != null ? +v[0] : v[1] != null ? +v[1] * 2.54 : null; };
  const widthIn = (r, wi) => { const v = r[wi + 1]; if (!v) return null; return v[1] != null ? +v[1] : v[0] != null ? +v[0] / 2.54 : null; };
  /* sizes the product really sells: the size buttons on the page (sold out ones are kept and flagged) */
  function soldSizes(root) {
    const m = new Map();
    /* a size reads as sold out only once the colour is known: with colours and none picked, the page marks sizes against no colour at all */
    const known = !$(".pp-c[data-v]", root) || !!$(".pp-c[data-v][aria-pressed=true]", root);
    $$(".pp-s[data-s]:not(.pp-o)", root).forEach((b) => m.set(b.dataset.s.trim().toUpperCase(), { name: b.dataset.s, na: known && b.classList.contains("pd-na") }));
    return m;
  }
  const inUnit = (c) => (c.root.classList.contains("un-cm") ? false : c.root.classList.contains("un-in") ? true : c.D.unit !== "cm");

  /* ---------- the rule: body -> chest -> wanted chest width -> size ---------- */
  function suggest(c, hcm, kg, fitId) {
    const R = c.rule, b = R.body, inp = R.input || {};
    const hr = inp.height_cm || [0, 1e9], wr = inp.weight_kg || [0, 1e9];
    if (hcm == null || kg == null || hcm < hr[0] || hcm > hr[1] || kg < wr[0] || kg > wr[1]) return { err: "bad" };
    const e = c.ease[fitId];
    if (e == null) return { err: "none" };
    let chest = b.chest_base_cm + b.chest_per_kg * kg + b.chest_per_cm_over_ref * (hcm - b.height_ref_cm);
    chest = Math.min(b.chest_max_cm || 1e9, Math.max(b.chest_min_cm || 0, chest));
    const target = (chest + e) / 2, tol = R.tolerance_cm != null ? R.tolerance_cm : 0, edge = R.edge_cm != null ? R.edge_cm : 0;
    const sold = soldSizes(c.root);
    const cand = c.G.rows.map((r) => ({ r, w: widthCm(r, c.wi), s: sold.get(String(r[0]).trim().toUpperCase()) })).filter((x) => x.w != null && x.s).sort((a, z) => a.w - z.w);
    if (!cand.length) return { err: "none" };
    let hit = cand.find((x) => x.w >= target - tol);
    if (!hit) { if (target - tol - cand[cand.length - 1].w > edge) return { err: "over" }; hit = cand[cand.length - 1]; }
    else if (cand[0].w - target > edge) return { err: "under" };
    const inch = inUnit(c), w = inch ? widthIn(hit.r, c.wi) : widthCm(hit.r, c.wi);
    const wtxt = inch ? (Math.round(w * 2) / 2).toString().replace(/\.0$/, "") + " in" : Math.round(w) + " cm";
    const note = (R.notes && R.notes[c.kind]) || "";
    const why = (note ? note + " " : "") + fill(R.why || "Size {size} is {w} across the chest laid flat.", { size: hit.s.name, w: wtxt });
    let model = "";
    (c.G.mo || []).filter((m) => m.cm && m.sz && sold.has(String(m.sz).trim().toUpperCase())).forEach((m) => { if (Math.abs(m.cm - hcm) <= (R.model_within_cm ?? 8) && (!model || Math.abs(m.cm - hcm) < model.d)) model = { d: Math.abs(m.cm - hcm), cm: m.cm, sz: m.sz }; });
    return { size: hit.s.name, na: hit.s.na, why, model: model ? fill(c.T.model || "", { cm: model.cm, size: model.sz }) : "" };
  }

  /* ---------- the sheet ---------- */
  let cur = null; /* { c, el, st } while the sheet is open */
  const parseH = (st) => (st.hu === "cm" ? num(st.cm) : (num(st.ft) == null && num(st.inch) == null ? null : ((num(st.ft) || 0) * 12 + (num(st.inch) || 0)) * 2.54));
  const parseW = (st) => { const v = num(st.w); return v == null ? null : st.wu === "kg" ? v : v * 0.45359237; };
  function form(c, st) {
    const T = c.T, fits = c.rule.fits || [["snug", T.fitSnug || "Snug"], ["regular", T.fitRegular || "Regular"], ["loose", T.fitLoose || "Loose"]];
    const tog = (k, a, b) => `<div class="pc-u" role="group">${[a, b].map((u) => `<button type="button" data-ff-u="${k}:${u[0]}" aria-pressed="${st[k] === u[0]}">${esc(u[1])}</button>`).join("")}</div>`;
    const inp = (k, ph, lab, step) => `<label class="ff-i"><input inputmode="decimal" data-ff="${k}" value="${esc(st[k] == null ? "" : st[k])}" placeholder="${esc(ph)}" aria-label="${esc(lab)}"><span>${esc(lab)}</span></label>`;
    const hd = (id, name, t) => `<div class="ff-hd"><span class="ff-lg" id="${id}">${esc(name)}</span>${t}</div>`;
    const ARR = '<svg class="ff-ar" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    return `<div class="pc-h"><div><span class="lab">${esc(T.title)}</span><h3>${esc(c.G.n)}</h3></div><button type="button" class="pc-x" data-pd-fit-close aria-label="${esc(T.close)}">${X}</button></div>
      <p class="ff-intro">${esc(T.intro)}</p>
      <form class="ff" novalidate>
        <div class="ff-r" role="group" aria-labelledby="ff-h">${hd("ff-h", T.height, tog("hu", ["ftin", "ft in"], ["cm", "cm"]))}
          <div class="ff-f">${st.hu === "cm" ? inp("cm", "175", "cm") : inp("ft", "5", "ft") + inp("inch", "9", "in")}</div></div>
        <div class="ff-r" role="group" aria-labelledby="ff-w">${hd("ff-w", T.weight, tog("wu", ["lb", "lb"], ["kg", "kg"]))}
          <div class="ff-f">${inp("w", st.wu === "kg" ? "75" : "165", st.wu)}</div></div>
        <div class="ff-r" role="group" aria-labelledby="ff-t">${hd("ff-t", T.fit, "")}<div class="ff-fit">${fits.filter((f) => c.ease[f[0]] != null).map((f) => `<button type="button" data-ff-fit="${esc(f[0])}" aria-pressed="${st.fit === f[0]}">${esc(f[1])}</button>`).join("")}</div></div>
        <button type="submit" class="btn ff-go"><span>${esc(T.go)}</span>${ARR}</button>
      </form>
      <div class="ff-res" aria-live="polite"></div>`;
  }
  function run(auto) {
    const { c, el, st } = cur, out = $(".ff-res", el), T = c.T;
    const r = suggest(c, parseH(st), parseW(st), st.fit);
    if (r.err) { out.innerHTML = auto ? "" : `<p class="ff-err">${esc(T[r.err] || T.none)}</p>`; return; }
    mem.set({ hu: st.hu, wu: st.wu, ft: st.ft, inch: st.inch, cm: st.cm, w: st.w, fit: st.fit });
    out.innerHTML = `<div class="ff-card"><div class="ff-rs"><small>${esc(T.result)}</small><b>${esc(r.size)}</b></div><p class="ff-why">${esc(r.why)}</p>${r.model ? `<p class="ff-mo">${esc(r.model)}</p>` : ""}${r.na ? `<p class="ff-err">${esc(T.sold)}</p>` : ""}
      <button type="button" class="btn pp-cxs ff-sel" data-ff-pick="${esc(r.size)}">${esc(fill(T.select, { size: r.size }))}</button><p class="ff-nt">${esc(T.note)}</p>${T.disclaimer ? `<p class="ff-nt ff-dis">${esc(T.disclaimer)}</p>` : ""}</div>`;
  }
  function paintForm() {
    const { c, el, st } = cur;
    $(".pdp-sp", el).innerHTML = form(c, st);
    if (st.__ran) run(false);
  }
  function open(btn) {
    const root = btn.closest('[data-ita="pdp"]') || $('[data-ita="pdp"]');
    const c = ctxOf(root);
    if (!c) { $$("[data-pd-fit-open]", root || document).forEach((b) => (b.hidden = true)); return; }
    const inRoot = $("[data-pd-fitsheet]", root);
    if (inRoot) $$("body > [data-pd-fitsheet]").forEach((x) => x.remove()); /* a sheet left over from a swapped product */
    const el = inRoot || $("body > [data-pd-fitsheet]");
    if (!el) return;
    if (!inRoot) { /* already moved to the body on an earlier open of this product */ } else document.body.appendChild(el); /* fixed layer outside transformed parents */
    const m = mem.get(), inch = inUnit(c);
    const st = {
      hu: m.hu || (inch ? "ftin" : "cm"), wu: m.wu || (inch ? "lb" : "kg"), ft: m.ft, inch: m.inch, cm: m.cm, w: m.w,
      fit: c.ease[m.fit] != null ? m.fit : c.ease.regular != null ? "regular" : Object.keys(c.ease)[0],
    };
    el.classList.toggle("ff-old", root.classList.contains("sz-old")); /* size_look = today keeps the older sheet look */
    cur = { c, el, st, opener: btn };
    paintForm();
    el.classList.add("on"); document.documentElement.style.overflow = "hidden";
    const have = parseH(st) != null && parseW(st) != null;
    if (have) run(true);
    const sp = $(".pdp-sp", el); sp && sp.focus();
  }
  function close() {
    if (!cur) return;
    cur.el.classList.remove("on"); document.documentElement.style.overflow = "";
    const o = cur.opener; cur = null; o && o.focus && o.focus();
  }
  function pick(size) {
    const c = cur.c, b = $$(".pp-s[data-s]:not(.pp-o)", c.root).find((x) => x.dataset.s === size);
    close();
    if (!b) return;
    b.click();
    const l = $("[data-pd-live]", c.root); if (l) { l.textContent = ""; setTimeout(() => (l.textContent = size + " " + (c.D.t && c.D.t.selected ? c.D.t.selected : "")), 30); }
    try { b.scrollIntoView({ block: "center", behavior: matchMedia("(prefers-reduced-motion:reduce)").matches ? "auto" : "smooth" }); } catch (e) {}
  }

  document.addEventListener("click", (e) => {
    const t = e.target;
    const o = t.closest && t.closest("[data-pd-fit-open]"); if (o) { e.preventDefault(); open(o); return; }
    if (!cur || !cur.el.contains(t)) return;
    if (t.closest("[data-pd-fit-close]")) { close(); return; }
    const p = t.closest("[data-ff-pick]"); if (p) { pick(p.dataset.ffPick); return; }
    const u = t.closest("[data-ff-u]"); if (u) { const [k, v] = u.dataset.ffU.split(":"); cur.st[k] = v; cur.st.__ran = false; paintForm(); const i = $("[data-ff]", cur.el); i && i.focus(); return; }
    const f = t.closest("[data-ff-fit]"); if (f) { cur.st.fit = f.dataset.ffFit; $$("[data-ff-fit]", cur.el).forEach((x) => x.setAttribute("aria-pressed", x === f)); if (parseH(cur.st) != null && parseW(cur.st) != null) run(true); return; }
  });
  document.addEventListener("input", (e) => { if (cur && e.target.dataset && e.target.dataset.ff) cur.st[e.target.dataset.ff] = e.target.value; });
  document.addEventListener("submit", (e) => { if (cur && e.target.closest && e.target.closest(".ff") && cur.el.contains(e.target)) { e.preventDefault(); cur.st.__ran = true; run(false); } });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && cur) close(); });

  /* ---------- the inline expander (fit_find_style = inline): a bar under the size buttons, no modal ---------- */
  const FX = new WeakMap(); /* mount -> state; a swapped product prints a new mount, so state is rebuilt from the remembered answers */
  const fxRoot = (m) => m.closest('[data-ita="pdp"]');
  const fxRow = (m) => m.closest(".pp-row") || fxRoot(m);
  const fxSizeBtns = (m) => $$(".pp-s[data-s]:not(.pp-o)", fxRow(m));
  const stOf = (m) => {
    let st = FX.get(m); if (st) return st;
    const c = ctxOf(fxRoot(m)); if (!c) return null;
    const mm = mem.get(), inch = inUnit(c);
    st = { hu: mm.hu || (inch ? "ftin" : "cm"), wu: mm.wu || (inch ? "lb" : "kg"), ft: mm.ft, inch: mm.inch, cm: mm.cm, w: mm.w, open: false, res: false, err: "",
      fit: c.ease[mm.fit] != null ? mm.fit : c.ease.regular != null ? "regular" : Object.keys(c.ease)[0] };
    FX.set(m, st); return st;
  };
  /* the tag: only on the button of the size we suggest, moved live when the fit changes */
  function fxMark(m, c, st) {
    const r = st.res ? suggest(c, parseH(st), parseW(st), st.fit) : null;
    fxSizeBtns(m).forEach((b) => {
      const on = !!r && !r.err && b.dataset.s === r.size, tg = $(".fx-tg", b);
      b.classList.toggle("fx-rec", on);
      if (on && !tg) b.insertAdjacentHTML("beforeend", `<span class="fx-tg">${esc(c.T.tag || "For you")}</span>`);
      else if (on && tg) tg.textContent = c.T.tag || "For you";
      else if (!on && tg) tg.remove();
    });
    return r;
  }
  function fxPaint(m) {
    const c = ctxOf(fxRoot(m)), st = stOf(m); if (!c || !st) { m.hidden = true; return; }
    const T = c.T, body = $("[data-pd-fit-body]", m), bar = $("[data-pd-fit-bar]", m);
    const fits = (c.rule.fits || [["snug", T.fitSnug || "Snug"], ["regular", T.fitRegular || "Regular"], ["loose", T.fitLoose || "Loose"]]).filter((f) => c.ease[f[0]] != null);
    const r = fxMark(m, c, st), shown = st.res && r && !r.err;
    m.classList.toggle("open", st.open); bar.setAttribute("aria-expanded", String(st.open)); body.hidden = !st.open;
    const hint = $("[data-pd-fit-hint]", m); if (hint) hint.textContent = shown ? fill(T.done || "Suggested {size}", { size: r.size }) : T.hint || "";
    if (!st.open) return;
    const use = (u) => esc(fill(T.use || "Use {unit}", { unit: u }));
    const inp = (k, ph, lab) => `<label class="fx-b"><input inputmode="decimal" data-ff="${k}" value="${esc(st[k] == null ? "" : st[k])}" placeholder="${esc(ph)}" aria-label="${esc(lab)}"><span>${esc(lab)}</span></label>`;
    if (!shown) {
      body.innerHTML = `<div class="fx-rw"><span class="fx-lb">${esc(T.height)}</span><div class="fx-bx">${st.hu === "cm" ? inp("cm", "175", "cm") : inp("ft", "5", "ft") + inp("inch", "9", "in")}</div><button type="button" class="fx-un" data-fx-u="hu">${use(st.hu === "cm" ? "ft in" : "cm")}</button></div>
        <div class="fx-rw"><span class="fx-lb">${esc(T.weight)}</span><div class="fx-bx">${inp("w", st.wu === "kg" ? "75" : "165", st.wu)}</div><button type="button" class="fx-un" data-fx-u="wu">${use(st.wu === "kg" ? "lb" : "kg")}</button></div>
        <div class="fx-rw fx-rf"><span class="fx-lb" id="fx-ft">${esc(T.fitin || T.fit)}</span><div class="fx-ch" role="group" aria-labelledby="fx-ft">${fits.map((f) => `<button type="button" data-fx-fit="${esc(f[0])}" aria-pressed="${st.fit === f[0]}">${esc(f[1])}</button>`).join("")}</div></div>
        ${st.err ? `<p class="ff-err" role="alert">${esc(st.err)}</p>` : ""}
        <button type="button" class="fx-go" data-fx-go>${esc(T.go)}</button>`;
    } else {
      const alt = fits.map((f) => { const a = suggest(c, parseH(st), parseW(st), f[0]); return `<button type="button" data-fx-fit="${esc(f[0])}" aria-pressed="${st.fit === f[0]}"><span>${esc(f[1])}</span><b>${a.err ? "-" : esc(a.size)}</b></button>`; }).join("");
      body.innerHTML = `<div class="fx-rr" aria-live="polite"><div class="fx-L">${esc(r.size)}</div><div class="fx-tx"><div class="fx-a">${esc(T.result)}</div><p>${esc(r.why)}</p></div></div>
        <div class="fx-alt" role="group">${alt}</div>
        ${r.model ? `<p class="fx-mo">${esc(r.model)}</p>` : ""}${r.na ? `<p class="ff-err">${esc(T.sold)}</p>` : ""}
        <div class="fx-acts"><button type="button" class="fx-use" data-fx-use="${esc(r.size)}">${esc(fill(T.select, { size: r.size }))}</button><button type="button" class="fx-ed" data-fx-edit>${esc(T.edit || "Edit")}</button></div>
        <p class="fx-nt">${esc(T.note)}</p>${T.disclaimer ? `<p class="fx-nt fx-dis">${esc(T.disclaimer)}</p>` : ""}`;
    }
  }
  /* the suggestion from the typed numbers; an unreadable or out of range answer stays on the form with the rule's message */
  function fxGo(m) {
    const c = ctxOf(fxRoot(m)), st = stOf(m); if (!c || !st) return;
    const r = suggest(c, parseH(st), parseW(st), st.fit);
    if (r.err) { st.res = false; st.err = c.T[r.err] || c.T.none; fxPaint(m); return; }
    st.err = ""; st.res = true;
    mem.set({ hu: st.hu, wu: st.wu, ft: st.ft, inch: st.inch, cm: st.cm, w: st.w, fit: st.fit });
    fxPaint(m);
  }
  /* switching unit keeps the number the visitor typed (converted) */
  function fxUnit(m, k) {
    const st = stOf(m); if (!st) return;
    if (k === "hu") {
      const cm = parseH(st);
      if (st.hu === "cm") { st.hu = "ftin"; if (cm != null) { const t = Math.round(cm / 2.54); st.ft = Math.floor(t / 12); st.inch = t % 12; } }
      else { st.hu = "cm"; if (cm != null) st.cm = Math.round(cm); }
    } else {
      const kg = parseW(st);
      if (st.wu === "lb") { st.wu = "kg"; if (kg != null) st.w = Math.round(kg); }
      else { st.wu = "lb"; if (kg != null) st.w = Math.round(kg / 0.45359237); }
    }
    st.err = ""; fxPaint(m);
    const i = $("[data-ff]", m); i && i.focus();
  }
  function fxPick(m, size) {
    const st = stOf(m), c = ctxOf(fxRoot(m)); if (!st || !c) return;
    const b = fxSizeBtns(m).find((x) => x.dataset.s === size);
    st.open = false; fxPaint(m);
    if (!b) return;
    b.click();
    const l = $("[data-pd-live]", c.root); if (l) { l.textContent = ""; setTimeout(() => (l.textContent = size + " " + (c.D.t && c.D.t.selected ? c.D.t.selected : "")), 30); }
  }
  function fxOpen(m) {
    const st = stOf(m); if (!st) { m.hidden = true; return; }
    st.open = !st.open;
    /* a visitor who answered before gets the answer straight away */
    if (st.open && !st.res && !st.err && !st.seen) { st.seen = true; if (parseH(st) != null && parseW(st) != null) { const c = ctxOf(fxRoot(m)); if (c && !suggest(c, parseH(st), parseW(st), st.fit).err) st.res = true; } }
    fxPaint(m);
    if (st.open) { try { m.scrollIntoView({ block: "nearest", behavior: matchMedia("(prefers-reduced-motion:reduce)").matches ? "auto" : "smooth" }); } catch (e) {} }
  }
  document.addEventListener("click", (e) => {
    const t = e.target, m = t.closest && t.closest("[data-pd-fit-in]"); if (!m) return;
    if (t.closest("[data-pd-fit-bar]")) { e.preventDefault(); fxOpen(m); return; }
    const st = stOf(m); if (!st) return;
    let x;
    if ((x = t.closest("[data-fx-u]"))) { e.preventDefault(); fxUnit(m, x.dataset.fxU); return; }
    if ((x = t.closest("[data-fx-fit]"))) {
      e.preventDefault(); st.fit = x.dataset.fxFit;
      if (st.res) fxPaint(m); /* result view: the tag moves live */
      else $$("[data-fx-fit]", m).forEach((b) => b.setAttribute("aria-pressed", b === x));
      return;
    }
    if (t.closest("[data-fx-go]")) { e.preventDefault(); fxGo(m); return; }
    if (t.closest("[data-fx-edit]")) { e.preventDefault(); st.res = false; st.err = ""; fxPaint(m); return; }
    if ((x = t.closest("[data-fx-use]"))) { e.preventDefault(); fxPick(m, x.dataset.fxUse); return; }
  });
  document.addEventListener("input", (e) => { const m = e.target.closest && e.target.closest("[data-pd-fit-in]"); if (m && e.target.dataset && e.target.dataset.ff) { const st = stOf(m); if (st) st[e.target.dataset.ff] = e.target.value; } });
  /* Enter in a field answers; it must never submit the product form (add to cart) around it */
  document.addEventListener("keydown", (e) => { const m = e.key === "Enter" && e.target.closest && e.target.closest("[data-pd-fit-in]"); if (m && e.target.matches("input")) { e.preventDefault(); fxGo(m); } });

  /* hide the link where the rule does not cover this garment (the server only checks that a chest width column exists) */
  function sweep() { $$("[data-pd-fit-open]").forEach((b) => { if (!ctxOf(b.closest('[data-ita="pdp"]'))) b.hidden = true; }); $$("[data-pd-fit-in]").forEach((m) => { if (!ctxOf(fxRoot(m))) m.hidden = true; }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sweep); else sweep();
})();
